let initGalleryFn = null;
let galleryApi = null;

export function registerProductGalleryInit(fn)
{
    initGalleryFn = fn;
}

export function setProductGalleryApi(api)
{
    galleryApi = api;
}

export function initImageSlider(slider, productType)
{
    if (typeof initGalleryFn === 'function') {
        initGalleryFn(slider, productType);
    }
}

export function changeSliderSlideVisible(number)
{
    if (galleryApi && typeof galleryApi.scrollTo === 'function') {
        galleryApi.scrollTo(parseInt(number, 10));
    }
}
